import { render } from "./RxDiagnosis.vue?vue&type=template&id=6856af74"
import script from "./RxDiagnosis.vue?vue&type=script&lang=js"
export * from "./RxDiagnosis.vue?vue&type=script&lang=js"

import "./RxDiagnosis.vue?vue&type=style&index=0&id=6856af74&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__